"use client";

import type { JSX } from "react";
import { motion, type Variants } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CONSULTATION_URL, SPECIALIST_URL } from "@/lib/consultation-links";
import { consultationCtaClassName } from "@/lib/cta-styles";

const headingVariants: Variants = {
  hidden: { opacity: 0, filter: "blur(8px)" },
  visible: {
    opacity: 1,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const consultationActions = [
  "Talk to a Specialist",
  "Book a Consultation Call",
];

export const ClientTrustAndTestimonialsSection = (): JSX.Element => {
  return (
    <section
      className="relative z-50 w-full bg-black"
      aria-labelledby="client-guidance-heading"
    >
            <div className="relative mx-auto min-h-[420px] w-full overflow-hidden sm:aspect-[1440/810]  2xl:aspect-[1440/617] sm:min-h-0 sm:max-h-[1017px]">
        <img
          className="absolute opacity-50 inset-0 h-full w-full object-cover"
          alt="Image"
          src="/home-v3/image-43.jpg"
        />
        <div className="absolute left-1/2 top-[25.9%] flex w-full sm:w-[min(60.42%,956px)] -translate-x-1/2 flex-col items-center gap-8">
          <header className="flex w-full flex-col items-center justify-center">
            <motion.h2
              id="client-guidance-heading"
              className="[font-family:'Suisse_Works_Trial-Bold',Helvetica] text-center text-[clamp(24px,3.34vw,48px)] font-bold leading-[1.242] tracking-[0] text-white"
              variants={headingVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.6 }}
            >
              Need Better Structure? <br />
              Get Clear Guidance
            </motion.h2>
          </header>
          <div className="flex flex-col items-center gap-[21px]">
            <div className="flex flex-wrap items-start justify-center gap-4">
              {consultationActions.map((action) => {
                const className = consultationCtaClassName(action);

                const href =
                  action === "Book a Consultation Call"
                    ? CONSULTATION_URL
                    : action === "Talk to a Specialist"
                      ? SPECIALIST_URL
                      : null;

                if (href) {
                  return (
                    <Button key={action} asChild className={className}>
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {action}
                      </a>
                    </Button>
                  );
                }

                return (
                  <Button key={action} type="button" className={className}>
                    {action}
                  </Button>
                );
              })}
            </div>
            <div className="flex items-center justify-center gap-5">
              <img
                className="w-[120px] h-5"
                alt="Frame"
                src="/home-v3/frame-122-1.png"
              />
              <p className="[font-family:'Suisse_Intl_Trial-Regular',Helvetica] whitespace-nowrap text-sm lg:text-[clamp(6px,1.25vw,18px)] font-normal leading-4 tracking-[0] text-white">
                100+ Reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
